var e = /* @__PURE__ */ ((t) => (t.registrationAttributes = "registrationAttributes", t.registrationAccountType = "registrationAccountType", t.shareCodeAttributes = "sharecodeAttributes", t.accountRenewalAttributes = "accountRenewalAttributes", t.registrationInfoKey = "registrationInfo", t))(e || {});
export {
  e
};
//# sourceMappingURL=profileConstantsEnum-b0e79f3e.mjs.map
